import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

const Login = () => import('./views/Login.vue')
const Alert = () => import('./views/Alert.vue')
const Alerts = () => import('./views/Alerts.vue')
const FloorPlans = () => import('./views/FloorPlans.vue')
const LogAlerts = () => import('./views/LogAlerts.vue')
const LogSync = () => import('./views/LogSync.vue')
const LogAudit = () => import('./views/LogAudit.vue')
const LogBatch = () => import('./views/LogBatch.vue')
const Tags = () => import('./views/Tags.vue')
const Tag = () => import('./views/Tag.vue')
const Gateways = () => import('./views/Gateways.vue')
const Gateway = () => import('./views/Gateway.vue')
const Consoles = () => import('./views/Consoles.vue')
const DistributionStations = () => import('./views/DistributionStations.vue')
const Device = () => import('./views/Device.vue')
const People = () => import('./views/People.vue')
const Subscriptions = () => import('./views/Subscriptions.vue')
const Zones = () => import('./views/Zones.vue')
const Users = () => import('./views/Users.vue')
const Keys = () => import('./views/Keys.vue')
const BigQueryReport = () => import('./views/BigQueryReport.vue')
const Reports = () => import('./views/Reports.vue')
const ReportDiagnostics = () => import('./views/ReportDiagnostics.vue')
const ReportAlertReasons = () => import('./views/ReportAlertReasons.vue')
const ReportTagsFlagged = () => import('./views/ReportTagsFlagged.vue')
const ReportTagsNotSeen = () => import('./views/ReportTagsNotSeen.vue')
const GatewayBatchOps = () => import('./views/GatewayBatchOps.vue')
const TagBatchOps = () => import('./views/TagBatchOps.vue')
const DistributionPick = () => import('./views/distribution/Pick.vue')
const DistributionHome = () => import('./views/distribution/Home.vue')
const DistributionTap = () => import('./views/distribution/Tap.vue')
const DistributionStatus = () => import('./views/distribution/Status.vue')
const DistributionCurrentTags = () => import('./views/distribution/CurrentTags.vue')
const DistributionActivate = () => import('./views/distribution/Activate.vue')
const DistributionSuccess = () => import('./views/distribution/Success.vue')
const FactoryHome = () => import('./views/factory/Home.vue')
const WarehouseHome = () => import('./views/warehouse/Home.vue')
const WarehouseReturns = () => import('./views/warehouse/Returns.vue')
const WarehouseLogistics = () => import('./views/warehouse/Logistics.vue')
const WarehouseInventory = () => import('./views/warehouse/Inventory.vue')
const Errors = () => import('./views/Errors.vue')

Vue.use(Router)

const routes = [{
  path: '/',
  name: 'home'
}, {
  path: '/login',
  name: 'login',
  component: Login,
  meta: {
    noAuth: true,
    layout: 'empty'
  }
}, {
  path: '/alerts',
  name: 'alerts',
  component: Alerts,
  meta: {
    rule: (can) => can('read', 'Alert')
  }
}, {
  path: '/gateways',
  name: 'gateways',
  component: Gateways,
  props: true,
  meta: {
    rule: (can) => can('read', 'Gateway')
  }
}, {
  path: '/consoles',
  name: 'consoles',
  component: Consoles,
  meta: {
    rule: (can) => can('read', 'Console')
  }
}, {
  path: '/distribution-stations',
  name: 'distribution-stations',
  component: DistributionStations,
  meta: {
    rule: (can) => can('read', 'DistributionStation')
  }
}, {
  path: '/tags',
  name: 'tags',
  component: Tags,
  props: true,
  meta: {
    rule: (can) => can('manage', 'Tag')
  }
}, {
  path: '/people',
  name: 'people',
  component: People,
  props: true,
  meta: {
    rule: (can) => can('read', 'Person')
  }
}, {
  path: '/floorplans',
  name: 'floorplans',
  component: FloorPlans,
  meta: {
    rule: (can) => can('read', 'FloorPlan'),
    layout: window.GatewayMobileApp ? 'empty' : 'default'
  }
}, {
  path: '/log/alerts',
  name: 'alertLogs',
  component: LogAlerts,
  meta: {
    rule: (can) => can('read', 'LogAlert')
  }
}, {
  path: '/log/sync',
  name: 'syncLogs',
  component: LogSync,
  meta: {
    rule: (can) => can('read', 'LogSync')
  }
}, {
  path: '/log/audit/:requestId?',
  name: 'auditLogs',
  component: LogAudit,
  props: true,
  meta: {
    rule: (can) => can('read', 'LogAudit')
  }
}, {
  path: '/log/batch',
  name: 'batchOperationLogs',
  component: LogBatch,
  props: true,
  meta: {
    rule: (can) => can('read', 'LogBatch')
  }
}, {
  path: '/reports',
  name: 'reports',
  component: Reports,
  meta: {
    rule: (can) => can('manage', 'Report')
  }
}, {
  path: '/reports/diagnostics',
  name: 'diagnostics-report',
  component: ReportDiagnostics,
  meta: {
    rule: (can) => can('read', 'Metrics')
  }
}, {
  path: '/reports/alerts_reasons',
  name: 'alert-reasons-report',
  component: ReportAlertReasons,
  meta: {
    rule: (can) => can('read', 'Report')
  }
}, {
  path: '/reports/tags-flagged',
  name: 'tags-flagged-report',
  component: ReportTagsFlagged,
  meta: {
    rule: (can) => can('manage', 'Tag')
  }
}, {
  path: '/reports/tags-flagged/details',
  name: 'tags-flagged-report-details',
  component: Tags,
  props: true,
  meta: {
    rule: (can) => can('manage', 'Tag')
  }
}, {
  path: '/reports/tags-not-seen',
  name: 'tags-not-seen-report',
  component: ReportTagsNotSeen,
  meta: {
    rule: (can) => can('manage', 'Tag')
  }
}, {
  path: '/reports/tags-not-seen/details',
  name: 'tags-not-seen-report-details',
  component: Tags,
  props: true,
  meta: {
    rule: (can) => can('manage', 'Tag')
  }
}, {
  path: '/reports/:id',
  name: 'bigquery-report',
  component: BigQueryReport,
  props: true,
  meta: {
    rule: (can) => can('manage', 'AdminReport')
  }
}, {
  path: '/operations/gateways',
  name: 'gateway-batch-ops',
  component: GatewayBatchOps,
  props: true,
  meta: {
    rule: (can) => can('manage', 'Gateway')
  }
}, {
  path: '/operations/tags',
  name: 'tag-batch-ops',
  component: TagBatchOps,
  props: true,
  meta: {
    rule: (can) => can('manage', 'Tag')
  }
}, {
  path: '/tag/:id',
  name: 'tag',
  component: Tag,
  props: true,
  meta: {
    rule: (can) => can('read', 'Tag')
  }
}, {
  path: '/gateway/:id',
  name: 'gateway',
  component: Gateway,
  props: true,
  meta: {
    rule: (can) => can('read', 'Gateway')
  }
}, {
  path: '/v1/:type/:id([0-9A-Fa-f]{12})',
  name: 'deviceV1',
  component: Device,
  props: true,
  meta: {
    noAuth: true,
    layout: 'logo'
  }
}, {
  path: '/subscriptions',
  name: 'subscriptions',
  component: Subscriptions,
  meta: {
    rule: (can) => can('read', 'Subscription')
  }
}, {
  path: '/zones',
  name: 'zones',
  component: Zones,
  meta: {
    rule: (can) => can('manage', 'Zone')
  }
}, {
  path: '/users',
  name: 'users',
  component: Users,
  meta: {
    rule: (can) => can('read', 'User')
  }
}, {
  path: '/keys',
  name: 'keys',
  component: Keys,
  meta: {
    rule: (can) => can('read', 'User')
  }
}, {
  path: '/alert/:id',
  name: 'alert',
  component: Alert,
  props: true,
  meta: {
    rule: (can) => can('read', 'Alert')
  }
}, {
  path: '/error/:code',
  name: 'error',
  component: Errors,
  props: true,
  meta: {
    noAuth: true,
    layout: 'logo'
  }
}, {
  path: '/distribution',
  name: 'distribution-pick',
  component: DistributionPick,
  props: true,
  meta: {
    layout: 'empty',
    authMethod: 'key',
    rule: (can) => can('read', 'DistributionStation')
  }
}, {
  path: '/distribution/:station',
  redirect: '/distribution/:station/home'
}, {
  path: '/distribution/:station/home',
  name: 'distribution-home',
  component: DistributionHome,
  props: true,
  meta: {
    layout: 'kiosk',
    authMethod: 'key',
    rule: (can) => can('read', 'Person')
  }
}, {
  path: '/distribution/:station/tap',
  name: 'distribution-tap',
  component: DistributionTap,
  props: true,
  meta: {
    layout: 'kiosk',
    rule: (can) => can('read', 'DistributionStation')
  }
}, {
  path: '/distribution/:station/status',
  name: 'distribution-status',
  component: DistributionStatus,
  props: true,
  meta: {
    layout: 'kiosk',
    rule: (can) => can('update', 'Tag')
  }
}, {
  path: '/distribution/:station/activate',
  name: 'distribution-activate',
  component: DistributionActivate,
  props: true,
  meta: {
    layout: 'kiosk',
    rule: (can) => can('update', 'Tag')
  }
}, {
  path: '/distribution/:station/current-tags',
  name: 'distribution-current-tags',
  component: DistributionCurrentTags,
  props: true,
  meta: {
    layout: 'empty',
    rule: (can) => can('update', 'Tag')
  }
}, {
  path: '/distribution/:station/success',
  name: 'distribution-success',
  component: DistributionSuccess,
  props: true,
  meta: {
    layout: 'kiosk'
  }
}, {
  path: '/factory/home',
  name: 'factory-home',
  component: FactoryHome,
  meta: {
    layout: 'kiosk'
  }
}, {
  path: '/warehouse/home',
  name: 'warehouse-home',
  component: WarehouseHome,
  props: true,
  meta: {
    layout: 'kiosk'
  }
}, {
  path: '/warehouse/returns',
  name: 'warehouse-returns',
  component: WarehouseReturns,
  props: true,
  meta: {
    layout: 'kiosk',
    rule: (can) => can('manage', 'Inventory')
  }
}, {
  path: '/warehouse/logistics/receive',
  name: 'warehouse-logistics-receive',
  component: WarehouseLogistics,
  props: true,
  meta: {
    layout: 'kiosk',
    rule: (can) => can('manage', 'Inventory')
  }
}, {
  path: '/warehouse/logistics/ship',
  name: 'warehouse-logistics-ship',
  component: WarehouseLogistics,
  props: true,
  meta: {
    layout: 'kiosk',
    rule: (can) => can('manage', 'Inventory')
  }
}, {
  path: '/warehouse/inventory',
  name: 'warehouse-inventory',
  component: WarehouseInventory,
  meta: {
    layout: 'kiosk',
    rule: (can) => can('read', 'Tag')
  }
}, {
  path: '/:id([0-9A-Fa-f]{12})',
  name: 'device',
  component: Device,
  props: true,
  meta: {
    noAuth: true,
    layout: 'logo'
  }
}, {
  path: '*',
  redirect: '/error/404'
}]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

function authReady () {
  return new Promise((resolve) => {
    if (!store.getters['auth/loading']) {
      return resolve()
    }

    const unwatch = store.watch(
      (state, getters) => getters['auth/loading'],
      () => {
        unwatch()
        resolve()
      }
    )
  })
}

function home (after) {
  const can = store.getters['auth/can']
  const route = routes.find(route => route.meta && route.meta.rule && route.meta.rule(can))
  return route ? route.name : { name: 'error', params: { code: 403 } }
}

async function ifLoggedIn (to, from, next) {
  await authReady()
  const after = (to.matched.find(({ name }) => name && name !== 'login') || {}).name
  const can = store.getters['auth/can']
  const user = store.getters['auth/user']
  if (user) {
    if (user.role === 'distribution' && !to.name.includes('distribution')) {
      return router.push({ name: 'distribution-pick' })
    } else if (user.role === 'factory' && !to.name.includes('factory')) {
      return router.push({ name: 'factory-home' })
    } else if (user.role === 'warehouse' && !to.name.includes('warehouse')) {
      return router.push({ name: 'warehouse-home' })
    } else if (user.role === 'noAccess') {
      return router.push({ name: 'error', params: { noAccess: true } })
    }
    if (to.name === 'home') {
      return router.push(home())
    }
    if (to.meta.rule && !to.meta.rule(can)) {
      return next({ name: 'error', params: { code: 403 } })
    }
    return next()
  }
  next({
    name: 'login',
    query: {
      after,
      ...(to.meta.authMethod && { method: to.meta.authMethod }),
      ...(to.query ? to.query : {})
    }
  })
}

async function ifNotLoggedIn (to, from, next) {
  await authReady()
  if (!store.getters['auth/user']) {
    return next()
  }
  return router.push(home())
}

router.beforeEach((to, from, next) => {
  const noAuth = to.matched.some(record => record.meta.noAuth)
  if (to.name === 'login') {
    return ifNotLoggedIn(to, from, next)
  } else if (!noAuth) {
    return ifLoggedIn(to, from, next)
  }
  next()
})

export default router
